import { RootState } from "../../Presentation/store";

export const selectAccounts = (state: RootState) =>
  Array.isArray(state.account.list) ? state.account.list : [];
export const selectAccountLoading = (state: RootState) => state.account.loading;
